module.exports = __webpack_public_path__ + "img/09.54f26148.png";